import { createContext, PropsWithChildren, useContext } from "react";

const CodeContext = createContext<string>("");

export const useCodeContext = ()=>{
    return useContext(CodeContext);
}

export interface CodeProviderProps extends PropsWithChildren{
    code:string
}

export const CodeProvider = ({ code, children }:CodeProviderProps)=>{
    return <CodeContext.Provider value={code}>
        {children}
    </CodeContext.Provider>
}